"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCheckboxPropertySelector = void 0;
var checkbox_property_selector_1 = require("./checkbox-property-selector");
Object.defineProperty(exports, "createCheckboxPropertySelector", { enumerable: true, get: function () { return checkbox_property_selector_1.createCheckboxPropertySelector; } });
//# sourceMappingURL=index.js.map